module.exports = __webpack_public_path__ + "img/9_9.8ba11d82.png";